import React from "react";
import { Button, type ButtonProps } from "@mui/material";

import { useAuthentication } from "../../hooks";
import type { ApplicationName } from "../../types";

type ApplicationButtonColor = "brandGreen" | "brandRust" | "brandBlue" | "info";

const getButtonColor = (applicationName: ApplicationName, applicationEnvironment?: string): ApplicationButtonColor => {
	if (applicationEnvironment === "preprod") {
		return "info";
	}

	if (applicationName === "TenantManagement" || applicationName === "Company") {
		return "brandRust";
	}

	if (applicationName === "Support") {
		return "brandBlue";
	}

	return "brandGreen";
};

type AuthenticationButtonProps = Omit<ButtonProps, "color">;

export const AuthenticationButton: React.FC<AuthenticationButtonProps> = (props) => {
	const { applicationName, applicationEnvironment } = useAuthentication();

	return <Button color={getButtonColor(applicationName, applicationEnvironment)} {...props} />;
};
